// src/services/tokenService.js
import api from './api';

let isRefreshing = false;
let queue = []; // { resolve, reject }[]

function processQueue(err, token = null) {
  queue.forEach(p => {
    if (err) p.reject(err);
    else    p.resolve(token);
  });
  queue = [];
}

/**
 * Возвращает Promise нового accessToken.
 * Если уже идёт запрос — вернёт Promise, который разрешится при его окончании.
 */
export function refreshToken() {
  if (isRefreshing) {
    return new Promise((resolve, reject) => {
      queue.push({ resolve, reject });
    });
  }

  isRefreshing = true;
  return api
    .get('/auth/refresh')
    .then(resp => {
      const newToken = resp.tokens?.access ?? resp.accessToken;
      if (!newToken) throw new Error('No access token in refresh response');
      processQueue(null, newToken);
      return newToken;
    })
    .catch(err => {
      processQueue(err, null);
      throw err;
    })
    .finally(() => {
      isRefreshing = false;
    });
}
